import { render, staticRenderFns } from "./ItemDetail.vue?vue&type=template&id=7cd3ee64"
import script from "../../controllers/item/item-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/item/item-detail.js?vue&type=script&lang=js&external"
import style0 from "./ItemDetail.vue?vue&type=style&index=0&id=7cd3ee64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports